import React,{useState} from 'react'
import {TextField,Box,LinearProgress,FormControl,InputLabel,Select,MenuItem} from '@material-ui/core' 
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Modal from '../generales/ModalCerrarActualiza';
import moment from 'moment'
import {llamaApiCargaToken,ErrorGeneral,llamadaApiCarga, llamadaApiToken } from '../funciones/ClienteAxios';
import { toast } from 'react-toastify'; 
import { obtenDispo } from '../funciones/IdDispositivo';
const ModalEditPerfil = ({modalAbierto,setModalAbierto ,titulo,perfil,listPerfil}) => {
    let history = useHistory();    
    const source = axios.CancelToken.source();  
    const usuID = localStorage.getItem('UsuId');
    const auxDispV =obtenDispo() 
    let fechaMax = moment(new Date()).subtract(18,'years')    
    const[nvoCliente,setNvoCliente]= useState({Llave:0,Nombre:'', FNacimien:fechaMax, Email:'' ,calle:'',
                                                Tel:'',ine:"",Municipio:"",Seccion:'',plantilla:0, Distrito:"",
                                                paterno:"",materno:""                                                
                                            });      
    const [espera,setEspera]= useState(false);
    const [mensaje, setMensaje] =  useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(true)
    const [aviso, setAviso] = useState(false);    
    const{ Llave, Nombre,FNacimien,Seccion,Tel,Municipio, Distrito, paterno,materno}=nvoCliente            
    const[arrError,setArrError] = useState([false,false,false,false,false,false])   
    const[auxListSecc,setAuxListSecc]= useState([]);  
    const[listMun,setListMun]= useState([]);  
    const[listDistrito,setListDistrito]= useState([]);  
    
    React.useEffect(()=>{                      
       setNvoCliente({...nvoCliente,Distrito:perfil.DtoId,
            Llave:perfil.Id,
            Nombre:perfil.Nombre,
            Tel:perfil.Tel,                                            
            FNacimien: perfil.Nacimiento,
            Email:perfil.Email,
            paterno:perfil.Paterno, 
            materno: perfil.Materno
          //  Seccion:perfil.SeccId
        })    
        getListDto()
    },[])    
    
    const getListDto = () => {
        const data = qs.stringify({
            Usuario: usuID, Estado: process.env.REACT_APP_EDO,  ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
                let listNvo=[]
                auxiliar.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom} - ${element.ComNom}`})
                }); 
                setListDistrito(listNvo)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }
    
    const onChange = e =>
	{   
        let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$.@#_&-+()/:;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setNvoCliente({
                ...nvoCliente, //copiamos el nvocliente
                [e.target.name] : e.target.value//.toUpperCase()  
            })  
             setBtnDeshabilitado(false)                     
                        
                    
        }		
	};  
    const onChangeNumTel = e =>
	{   let expNopermitida= new RegExp('[A-Za-z$@#_&-+()/:;!?,<>=]');          
        let expMenos = new RegExp("'");
        let expMas = new RegExp('-');     
        let expCadena = new RegExp('[.0-9$]');             
        if (  e.target.value.length<=10 &&( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
            && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
            || e.target.value===' '|| e.target.value==='') 
        {
            setNvoCliente({
                ...nvoCliente, //copiamos el nvocliente
                [e.target.name] : e.target.value//.toUpperCase()  
            })            
            if (e.target.value.length>=8) {
                setBtnDeshabilitado(false)                     
            }            
            else{
                setBtnDeshabilitado(true)                     
            }
        }		    
	};            

    const verifiNombre = () => {                   
        let data = qs.stringify({
            cadena:Nombre.trim(),    
            idDispositivo: auxDispV,
        });
        let url = "perfil-verifica-cadena";
        llamadaApiCarga(data, url, respuestaNombre,ErrorGeneral,setEspera,history);
    };

    function respuestaNombre(auxiliar){        
        const isEmpty = Object.keys(auxiliar).length === 0                        
        let auxArr=arrError
        if (isEmpty || auxiliar.coincidencia===0 ||  auxiliar.coincidencia==="0"   ) 
        {                 
           // console.log(auxiliar);   
            auxArr[3]=false 
            setArrError(auxArr)
            //setAviso(false)   
            const auxFechaNacimient=moment( FNacimien).format('YYYY-MM-DD')  
            
            if (perfil.MunId!==Municipio.Id||perfil.Nombre!==Nombre.trim()) 
            {
                validaDuplicado(auxFechaNacimient)              
            }
            else{
                llamadaNvoPerfil()     
            }
                
        } 
        else 
        {   const mensaje = "Nombre invalido, ingrese un Nombre diferente.";
            toast.warning(mensaje,{
                pauseOnFocusLoss: false,                    
                toastId: `nvo-perfil${5}`
            })              
            mandaAlerta(mensaje, "warning");              
            auxArr[3]=true                                
            setArrError(auxArr)
            setBtnDeshabilitado(false)                            
        }
         
    }

    const validaDuplicado = (fecha) => {              
        const data = qs.stringify({
            nombre:Nombre.trim(),
            nacimiento:fecha+"T00:00:00",
            municipio:Municipio.Id,
            idDispositivo: auxDispV,
        });
        const url = "perfil-verifica-duplicado";
        llamadaApiCarga(data, url, respuestaDuplicado,ErrorGeneral,setEspera,history);
    };

    function respuestaDuplicado(auxiliar){        
        const isEmpty = Object.keys(auxiliar).length === 0
        let auxArr=arrError
        if (isEmpty || auxiliar.rechazo===0 ||  auxiliar.rechazo==="0"   ) 
        {   //             
            auxArr[3]=true     
            setArrError(auxArr)                 
            llamadaNvoPerfil()              
        } 
        else 
        {   //let mensaje = "Nombre ya registrado, ingrese un Nombre diferente.";
            const mensaje = auxiliar.mensaje//"Nombre ya registrado, ingrese un Nombre diferente.";
            toast.warning(mensaje,{
                pauseOnFocusLoss: false,                    
                toastId: `nvo-perfil${6}`
            })                                    
            mandaAlerta(mensaje, "warning");
            auxArr=arrError
            auxArr[3]=true                    
            setArrError(auxArr) 
            setBtnDeshabilitado(false)               
        }
    }    
 
    const llamadaNvoPerfil=()=>{                     
                
        const data = qs.stringify({
            usuario:usuID,
            llave:Llave,        
            nombre:Nombre,             
            seccion:Distrito,
            paterno:paterno,
            materno:materno,
            telefono:Tel,
            idDispositivo:auxDispV
        });
        function respuesta(aux){
            if (aux.length!==0 &&aux?.respuesta===1 ) 
            {                                        
                setBtnDeshabilitado(true)                                             
                let mensaje="Se edito correctamente."
                setTipoAdvertencia("success")      
                setMensaje(mensaje);                
                setAviso(false);
                toast.success(mensaje,{
                    pauseOnFocusLoss: false,                    
                    toastId: `edit-perfil${3}`
                })      
                
                let auxlistArray=listPerfil 
                const pos =auxlistArray.findIndex((pefl)=>pefl.Id===Llave) 
                const arrEdit={...perfil,Tel:Tel,Nombre:Nombre, Paterno:paterno, Materno:materno}
                auxlistArray.splice(pos, 1,arrEdit )  
                //console.log(auxlistArray);       
                setModalAbierto(false)
            }                            
        }
        const url = "perfil/v4/perfil/edit";
        llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setEspera,history,source);
    }    


    const onChangeSeccion=(e)=>{    
        if (e!== null && e!== undefined) 
        { //setMuniSelect(e)       
            setNvoCliente({
                ...nvoCliente,
                Distrito :e.target.value 
            })      
            setBtnDeshabilitado(false)   
            setMensaje('');                
            setAviso(false); 
        }else
        { setNvoCliente({
            ...nvoCliente,
            Distrito : ""  
        })           
        }        
    }  
    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;                  
        if( (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;                                
            mandaAlerta('No se lleno el campo '+descripcion,"warning")             
        }
        return(respuesta);
    }

    const mandaAlerta=(mensaje,tipoAdvert)=>
    {
        setMensaje(mensaje);
        setTipoAdvertencia(tipoAdvert)  
        setAviso(true);      
    }
      
    function validaVariable(auxCampo,auxMensaje,auxTamanio) 
    {   let respuesta=false
        if ( !verificaNulos(auxCampo,auxMensaje) ) 
        {   if (auxCampo.length>=auxTamanio ) 
            {                
                respuesta=true                    
            }else
            {            
                mandaAlerta('Campo '+auxMensaje +' incompleto, debe escribir un '+ auxMensaje+' valido',"warning") 
            }
        }        
        return respuesta;
    }
 
    function guardarDatos(e)
    {   e.preventDefault()                        
        if (!verificaNulos(Distrito,"Distrito")  &&validaVariable(Nombre,'Nombre',3)
            &&validaVariable(paterno,'Paterno',3)
        &&validaVariable(materno,'Materno',3)
            && validaVariable(Tel,'Telefono',8))
        {           
            setMensaje('');                
            setAviso(false);                
            setBtnDeshabilitado(true)               
            
           llamadaNvoPerfil()
        }                                  
    } 

    const DatosGenerales=(
        <div>     
            <Box   pt={1} mb={1} display="flex" flexDirection={"row"}>
  
                {listDistrito.length!==0 ?                
                <Box display={"flex"} mb={1}>
                <FormControl size='small'  style={{ width:16+'rem'}} >
                    <InputLabel size='small' variant="outlined" id="Distrito-label-nvo">Distrito</InputLabel>
                    <Select  size='small' variant="outlined"
                        label="Distrito" id="Distrito-select2" name="Distrito"
                        value={Distrito} onChange={onChangeSeccion}
                    >
                        {listDistrito.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{secc.Nom }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                    </FormControl>
                    </Box>
                :   null
                }
            </Box>      
            <Box display={"flex"} flexDirection={"row"}>
            <TextField required id="Nombre-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:12+'rem'}}
                label="Nombre" value={Nombre} name='Nombre'size="small" autoComplete='off' // defaultValue="Nombre"                
                //auxArrerror={arrError[3]} onBlur={()=>verifiNombre()}
            />   
            <TextField required id="paterno-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:10+'rem', marginLeft:"1rem"}}
                label="Apellido Paterno" value={paterno} name='paterno'size="small" autoComplete='off' // defaultValue="Nombre"                
                //auxArrerror={arrError[3]} onBlur={()=>verifiNombre()}
            />  
            <TextField required id="Materno-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:10+'rem', marginLeft:"1rem"}}
                label="Apellido Materno" value={materno} name='materno'size="small" autoComplete='off' // defaultValue="Nombre"                
                //auxArrerror={arrError[3]} onBlur={()=>verifiNombre()}
            />   
            </Box>                                                   
              <TextField  id="CInt-input" onChange={onChangeNumTel} style={{marginRight:1+'rem',width:8+'rem'}}
                label="Teléfono" defaultValue="Tel" value={Tel} name='Tel' size="small" type="number"
                inputProps= {{ maxlength: 12 }} autoComplete='off'
            />            
        </div> 
    )     

    const cerrarBorrar = () => {              
        setAviso(false);
        setModalAbierto(false);        
    };

    return (
    <>           
    <Modal
        titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} btnDeshabilitado={btnDeshabilitado}
        setAviso={setAviso} tamanio={'md'} cargando={espera}     
        cerrarBorrar={cerrarBorrar}   
    >
        {DatosGenerales}
    </Modal>         
    </>
    )
}

export default ModalEditPerfil